import React from 'react';
import {Link} from 'gatsby'

import BlogImg4 from '../../assets/images/blog/blog-img4.jpg'
import BlogImg5 from '../../assets/images/blog/blog-img5.jpg'
import BlogImg6 from '../../assets/images/blog/blog-img6.jpg'
import User1 from '../../assets/images/user1.jpg'
import User2 from '../../assets/images/tatuananh.jpg'
import User3 from '../../assets/images/user3.jpg'
import VectorShape1 from '../../assets/images/shape/vector-shape1.png'
import VectorShape2 from '../../assets/images/shape/vector-shape2.png'

const BlogPost = () => {
    return (
        <section className="blog-area pt-100 pb-70">
            <div className="container">
                <div className="section-title">
                    <h2>Latest Valuable Insights</h2>
                    <p>A little bit of everything, written by experts of GritBros team. Join our blog, we would love to hear from you..</p>
                </div>

                <div className="row">
                    <div className="col-lg-4 col-md-6">
                        <div className="single-blog-post bg-fffbf5">
                            <div className="post-image">
                                <Link to="/blog-details">
                                    <img src={BlogImg4} alt="Blog" />
                                </Link>
                            </div>

                            <div className="post-content">
                                <ul className="post-meta d-flex justify-content-between align-items-center">
                                    <li>
                                        <div className="post-author d-flex align-items-center">
                                            <img src={User1} className="rounded-circle" alt="User" />
                                            <span>Nam Nguyen</span>
                                        </div>
                                    </li>
                                    <li>
                                        <i className='flaticon-calendar'></i> April 30, 2020
                                    </li>
                                </ul>
                                <h3>
                                    <Link to="/blog-details">
                                        Six Styles to Make Your Web Look Modern
                                    </Link>
                                </h3>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="single-blog-post bg-fffbf5">
                            <div className="post-image">
                                <Link to="/blog-details">
                                    <img src={BlogImg5} alt="Blog" />
                                </Link>
                            </div>

                            <div className="post-content">
                                <ul className="post-meta d-flex justify-content-between align-items-center">
                                    <li>
                                        <div className="post-author d-flex align-items-center">
                                            <img src={User2} className="rounded-circle" alt="User" />
                                            <span>Anh Ta</span>
                                        </div>
                                    </li>
                                    <li>
                                        <i className='flaticon-calendar'></i> April 28, 2020
                                    </li>
                                </ul>
                                <h3>
                                    <Link to="/blog-details">
                                        The Challenges to Tackle Before You Use Big Data
                                    </Link>
                                </h3>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                        <div className="single-blog-post bg-fffbf5">
                            <div className="post-image">
                                <Link to="/blog-details">
                                    <img src={BlogImg6} alt="Blog" />
                                </Link>
                            </div>

                            <div className="post-content">
                                <ul className="post-meta d-flex justify-content-between align-items-center">
                                    <li>
                                        <div className="post-author d-flex align-items-center">
                                            <img src={User3} className="rounded-circle" alt="User" />
                                            <span>Tai Bui</span>
                                        </div>
                                    </li>
                                    <li>
                                        <i className='flaticon-calendar'></i> April 29, 2020
                                    </li>
                                </ul>
                                <h3>
                                    <Link to="/blog-details">
                                        Why Organisations Want Better Cyber Security?
                                    </Link>
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="vector-shape1">
                <img src={VectorShape1} alt="Vector Shape" />
            </div>
            <div className="vector-shape2">
                <img src={VectorShape2} alt="Vector Shape" />
            </div>
        </section>
    )
}

export default BlogPost;